import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateActionComponent } from 'app/dialogs/create-action/create-action.component';
import { NotificationDetailDialogComponent } from 'app/dialogs/notification-detail-dialog/notification-detail-dialog.component';

import { _isAuthenticated, _isId, AuthService } from 'app/services/auth.service';
import { ActionService } from 'app/services/models/action.service';
import { NotificationService } from 'app/services/models/notification.service';
import { UserNotificationService } from 'app/services/models/user-notification.service';
import { ToastrService } from 'ngx-toastr';

// Interface
/*
interface notification {
  messages: [];
  systemMessages: [];
  system: Boolean;
}*/

@Component({
  selector: 'app-navbar-notification',
  templateUrl: './navbar-notification.component.html'
})
export class NavbarNotificationComponent implements OnInit {

  public notifications: any = {};
  public isRefreshing: boolean = false; // Butonun durumu için

  public notificationsData: any[];
  constructor(
    private actionService: ActionService,
    private modalService: NgbModal,
    private authService: AuthService,
    private notificationSerivce: NotificationService,
    private userNotificationService: UserNotificationService,
    private toastrService: ToastrService,
    private router: Router
  ) {
    this.authService.identityCheck()
  }


  async ngOnInit() {
    if (_isAuthenticated && localStorage.getItem('accessToken')) {
      // if(this.authService.isEndpointStatus('GET.Reading.GetUserByIdAction')){
      //   await this.getUserByIdActions(_isId);
      // }
      this.notificationSerivce.notifications$.subscribe(async (notification) => {
        console.log(notification);
        await this.getNotExpiryNotifications();
      });
      await this.getNotExpiryNotifications();
    }
  }

  async getNotExpiryNotifications() {
    try {
      this.isRefreshing = true; // Butonu disable yap
      const data = await this.notificationSerivce.getNotExpiryNotifications();
      console.log(data);
      this.notificationsData = data;
    } catch (error) {
      console.error(error);
    } finally {
      this.isRefreshing = false; // İşlem tamamlandı, butonu aktif yap
    }
  }

  async createUserNotification(notificationId, isRead) {
    const listData = [
      {
        appUserId: _isId,
        notificationId: notificationId,
        isRead: isRead
      }
    ];
    const notification = this.notificationsData.find(p => p.id == notificationId);
    const modal = this.modalService.open(NotificationDetailDialogComponent, {
      size: 'lg',
      windowClass: `modal modal-${this.getAlertType(notification.type)}`,
      centered: true
    });
    modal.componentInstance.data = notification;
    const data = await this.userNotificationService.createUserNotification(listData);
    if (data.status) {
      // this.toastrService.success(data.message);
      await this.getNotExpiryNotifications();
    } else {
      this.toastrService.error(data.message);
    }
  }

  hasUnreadNotifications() {
    //this.router.navigate(["#/admin/user-notification", _isId]);
    return this.notificationsData?.some(n => !n.isRead) ?? false;
  }

  // Tümünü oku işlemi
  async markAllAsRead() {
    this.router.navigate(["/admin/user-notification/",_isId]);
    //if (!this.notificationsData?.length) return;
    /*
        const unreadNotifications = this.notificationsData
          .filter(n => !n.isRead)
          .map(n => ({
            appUserId: _isId,
            notificationId: n.id,
            isRead: true
          }));
    
        if (!unreadNotifications.length) return;
    
        const data = await this.userNotificationService.createUserNotification(unreadNotifications);
    
        if (data.status) {
          await this.getNotExpiryNotifications();
        } else {
          this.toastrService.error(data.message);
        }
      */
  }


  getUnreadCount(): number {
    if (!this.notificationsData) return 0;
    return this.notificationsData.filter(n => !n.isRead).length;
  }

  allRead(): boolean {
    return this.getUnreadCount() === 0;
  }

  getAlertType(type: number): string {
    switch (type) {
      case 1: return 'info';
      case 2: return 'success';
      case 3: return 'warning';
      case 4: return 'danger';
      default: return 'primary';
    }
  }


  // async getUserByIdActions(id) {
  //   const data = await this.actionService.getUserByIdAction(id);
  //   this.actions = data;
  //   console.log(this.actions);
  // }

  // showActionDetail(id) {
  //   const action = this.actions.find(p => p.id == id);
  //   const modal = this.modalService.open(CreateActionComponent, {
  //     size: 'lg',
  //     centered: true,
  //     windowClass: 'modal modal-success'
  //   })
  //   modal.componentInstance.data = {
  //     requestTask: action.requestTask,
  //     actionId: id
  //   };
  // }
}
